import {
  IconButton,
  ModalDefaultContent,
  ModalFooter,
  ModalHeader,
  ModalSizes,
  Modal as ReactModal,
  RoundButton,
  roundButtonStylesMedium,
} from "@smartsuite/react-ui/lib";
import { t } from "i18next";
import type { FunctionComponent } from "react";

import { GrayColors } from "@smartsuite/types";
import { translateIfPresent } from "../../../locales/i18n";
import { Underscored } from "../../AutomationActivity/ActivityHeader/styles";
import * as S from "./style";

interface ModalProps {
  onClose: () => void;
}

export const NotPermittedModal: FunctionComponent<ModalProps> = ({
  onClose,
}) => {
  const footerButtons = (
    <>
      <RoundButton styles={roundButtonStylesMedium} onClick={onClose}>
        {t("confirm-modal.close")}
      </RoundButton>
    </>
  );
  const footer = <ModalFooter buttons={footerButtons} />;

  return (
    <ReactModal
      size={ModalSizes.S}
      onClose={onClose}
      withoutHat={true}
      withoutHeader={true}
      header={
        <ModalHeader
          independent={true}
          title={t("caption.Automation Permissions")}
          actions={
            <S.CloseIconWrapper>
              <IconButton
                size="M"
                name="close"
                color={GrayColors["G-6"]}
                hoverColor={GrayColors["G-8"]}
                onClick={onClose}
                ariaLabel="Modal Close"
                style={{ position: "relative", left: "20px" }}
              />
            </S.CloseIconWrapper>
          }
        />
      }
      footer={footer}
    >
      <ModalDefaultContent>
        {translateIfPresent(
          `caption.You do not have permissions to view and modify this automation`,
          `You do not have permissions to view and modify this automation`,
        )}
        &nbsp;
        <Underscored
          onClick={(e) => {
            e.stopPropagation();
            window.open(
              "https://help.smartsuite.com/en/collections/3584897-smartsuite-automations",
              "_blank",
            );
          }}
        >
          {t("learn-more2")}
        </Underscored>
      </ModalDefaultContent>
    </ReactModal>
  );
};
